import { PaletteOptions } from '@mui/material/styles/createPalette';

export const lightPalette: PaletteOptions = {
  mode: 'light',

  primary: {
    main: '#009AD7',
    light: '#42A5f5',
    dark: '#006997',
    contrastText: '#FFFFFF',
  },

  secondary: {
    main: '#303030',
    light: '#b5b5b5',
    dark: '#1A1A1A',
    contrastText: '#FFFFFF',
  },

  info: {
    main: '#086DD9',
    light: '#42A5F5',
    dark: '#134085',
    contrastText: '#FFFFFF',
  },

  warning: {
    main: '#FF9800',
    light: '#FFB74D',
    dark: '#F57C00',
    contrastText: '#1A1A1A',
  },

  error: {
    main: '#DD1708',
    dark: '#991005',
    light: '#FF6666',
    contrastText: '#FFFFFF',
  },

  success: {
    main: '#008000',
    light: '#4CAF50',
    dark: '#388E3C',
    contrastText: '#FFFFFF',
  },

  text: {
    primary: '#212121',
    secondary: '#656565',
    disabled: '#9E9E9E',
  },

  background: {
    default: '#FFFFFF',
    paper: '#FFFFFF',
  },

  divider: '#E0E0E0',

  action: {
    active: '#0000008A',
    hover: '#0000000A',
    selected: '#00000014',
    disabled: '#00000042',
    disabledBackground: '#0000001F',
    focus: '#0000001F',
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
};

const colors = [
  '#a7e6cc',
  '#bbecd8',
  '#90e0be',
  '#ffffff',
  '#fbf8f3',
  '#f5f0e4',
  '#ccd0cb',

  '#9eccde',
  '#a7ccdb',
  '#86b7ca',
  '#ffffff',
  '#fbf8f3',
  '#f5f0e4',
  '#ccd0cb',
];
